(function () {
  'use strict';
  if (window.__zaClarityConsentInstalled) return;
  window.__zaClarityConsentInstalled = true;
  var loaded = false;
  var ready = false;
  var attempts = 0;
  function sync() {
    if (!ready) return;
    var allowed = window.Shopify.customerPrivacy.analyticsProcessingAllowed();
    document.documentElement.setAttribute('data-za-clarity', allowed ? 'allowed' : 'denied');
    if (!allowed && !loaded) return;
    window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    window.clarity('consentv2', { analytics_Storage: allowed ? 'granted' : 'denied', ad_Storage: 'denied' });
    if (loaded) return;
    loaded = true;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/xmbyuscxrk';
    script.id = 'za-clarity-script';
    document.head.appendChild(script);
  }
  document.addEventListener('visitorConsentCollected', sync);
  function init() {
    if (!window.Shopify || !window.Shopify.loadFeatures) {
      if (++attempts < 20) window.setTimeout(init, 250);
      return;
    }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
      if (error || !window.Shopify.customerPrivacy) return;
      ready = true;
      sync();
    });
  }
  init();
})();
